import React, { useState } from "react";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Table from "components/Table/Table.jsx";
import CustomInput from "components/CustomInput/CustomInputValidate";
import { cloneJ } from "../../shared/utility";
import Button from "../../components/CustomButtons/Button";
import { IconButton } from "@material-ui/core";
import { getSum } from "./CommissionSplitsLogic";
import NotificationAsk from "../../components/Notification/NotificationAsk";
import CustomCRMEditor from "../../components/CustomDialog/CustomCRMEditor";
import CTable from "./CTable";
// *************
// * REFERRALS *
// *************
//
// 'Pre-splits - Lessee',
// 'Pre-splits - Lessor',
// 'Pre-splits - Both',
// 'Lessor',
// 'Lessee'
//
const Step3 = (props) => {
    const [askBeforeDelete, setAskBeforeDelete] = useState(-1);
    const [edit, setEdit] = useState(null);
    const { dataObj, updateDataObj, setOpenedChooseModal, setQueryFor, currentUserIsSubmitter, currentUserIsAnAgentApprover } = props;
    const sum1 = getSum(dataObj.referrals);
    const sum2 = getSum(dataObj.outside_brokers);
    const total_sum = sum1 + sum2;
    const isCompleteTab = props.parentTab === 'my_completed' || props.parentTab === 'all_completed' ? 
        true : false;

    const pre_splits_lessee = dataObj.referrals.map((m,i) => {
        m.index = i;
        return m;
    }).filter(r => {
        if (r.referral_type === 'Pre-splits - Lessee') return true;
    });
    const pre_splits_lessor = dataObj.referrals.map((m,i) => {
        m.index = i;
        return m;
    }).filter(r => {
        if (r.referral_type === 'Pre-splits - Lessor') return true;
    });
    const pre_splits_both = dataObj.referrals.map((m,i) => {
        m.index = i;
        return m;
    }).filter(r => {
        if (r.referral_type === 'Pre-splits - Both') return true;
    });
    const lessor = dataObj.referrals.map((m,i) => {
        m.index = i;
        return m;
    }).filter(r => {
        if (r.referral_type === 'Lessor' || r.referral_type === 'Both') return true;
    });
    const lessee = dataObj.referrals.map((m,i) => {
        m.index = i;
        return m;
    }).filter(r => {
        if (r.referral_type === 'Lessee' || r.referral_type === 'Both') return true;
    });
        
    return <div className={currentUserIsAnAgentApprover || props.action === 'view' ? 'no-click' : ''}>
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <h3>Referrals</h3>
                {(props.parentTab !== 'my_completed' && props.parentTab !== 'all_completed') && <div>
                    {currentUserIsSubmitter && <Button color="primary" onClick={() => {
                        setQueryFor({
                            title: 'Select Referrals',
                            label: 'Select Referrals',
                            type: 'referrals'
                        })
                        setOpenedChooseModal(true)
                    }}>ADD NEW</Button>}
                </div>}
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>

                {pre_splits_lessee.length > 0 && <CTable 
                    field="referrals"
                    arr={pre_splits_lessee}
                    title="Pre-splits Lessee"
                    dataObj={dataObj}
                    updateDataObj={updateDataObj}
                    setEdit={setEdit}
                    isCompleteTab={isCompleteTab}
                    setAskBeforeDelete={setAskBeforeDelete}
                    total_sum={total_sum}
                    currentUserIsSubmitter={currentUserIsSubmitter}
                />}

                {pre_splits_lessor.length > 0 && <CTable 
                    field="referrals"
                    arr={pre_splits_lessor}
                    title="Pre-splits Lessor"
                    dataObj={dataObj}
                    updateDataObj={updateDataObj}
                    setEdit={setEdit}
                    isCompleteTab={isCompleteTab}
                    setAskBeforeDelete={setAskBeforeDelete}
                    total_sum={total_sum}
                    currentUserIsSubmitter={currentUserIsSubmitter}
                />}

                {pre_splits_both.length > 0 && <CTable 
                    field="referrals"
                    arr={pre_splits_both}
                    title="Pre-splits Both"
                    dataObj={dataObj}
                    updateDataObj={updateDataObj}
                    setEdit={setEdit}
                    isCompleteTab={isCompleteTab}
                    setAskBeforeDelete={setAskBeforeDelete}
                    total_sum={total_sum}
                    currentUserIsSubmitter={currentUserIsSubmitter}
                />}

                {lessee.length > 0 && <CTable 
                    field="referrals"
                    arr={lessee}
                    title="Lessee"
                    dataObj={dataObj}
                    updateDataObj={updateDataObj}
                    setEdit={setEdit}
                    isCompleteTab={isCompleteTab}
                    setAskBeforeDelete={setAskBeforeDelete}
                    total_sum={total_sum}
                    currentUserIsSubmitter={currentUserIsSubmitter}
                />}

                {lessor.length > 0 && <CTable 
                    field="referrals"
                    arr={lessor}
                    title="Lessor"
                    dataObj={dataObj}
                    updateDataObj={updateDataObj}
                    setEdit={setEdit}
                    isCompleteTab={isCompleteTab}
                    setAskBeforeDelete={setAskBeforeDelete}
                    total_sum={total_sum}
                    currentUserIsSubmitter={currentUserIsSubmitter}
                />}

            </GridItem>
        </GridContainer>

        {askBeforeDelete !== -1 && <NotificationAsk 
            title="Are you sure?"
            message="Do you want to remove this referral?"
            success={() => {
                if (props.parentTab === 'my_completed' || props.parentTab === 'all_completed') {
                    setAskBeforeDelete(-1);
                    return;
                }
                const newData = cloneJ(dataObj);
                newData.referrals = newData.referrals.filter((c,x) => {
                    if (x === askBeforeDelete) {
                        return false;
                    }
                    return true;
                })
                updateDataObj('referrals', newData.referrals);
                setAskBeforeDelete(-1);
            }}
            open={askBeforeDelete !== -1 ? true : false}
            close={() => {
                setAskBeforeDelete(-1);
            }}
        />}

        {edit !== null && <CustomCRMEditor 
            {...edit}
            close={() => {
                setEdit(null)
            }}
        />}
    </div>
}

export default Step3;